import type {
  DefaultError,
  UseMutationOptions,
} from '@tanstack/react-query'
import type {
  PaymentRequest,
  PaymentResponse,
} from '~/lib/services/api/payment'

import {
  useMutation,
} from '@tanstack/react-query'
import {
  createPayment,
} from '~/lib/services/api/payment'

interface CreatePaymentMutationData {
  orderId: string
  paymentData: PaymentRequest
}

function useCreatePayment() {
  const mutationFn = async ({
    orderId,
    paymentData,
  }: CreatePaymentMutationData) => {
    const response = await createPayment(orderId, paymentData)
    if (response.status !== 200) {
      throw new Error('Error creating payment')
    }
    return response.data
  }

  const options: UseMutationOptions<
    PaymentResponse,
    DefaultError,
    CreatePaymentMutationData,
    unknown
  > = {
    mutationFn,
  }

  return useMutation(options)
}

export default useCreatePayment
